import React from 'react';
import './Policy.css';

const ResponsibleTravel: React.FC = () => {
  return (
    <div className="page-container">
      <h2>Responsible Travel</h2>
      <p>
        Dear travellers, we all love travelling and nature is a home of all of us. We also have to show 
        respect for other travellers, private owners and of course the biggest asset we have – nature. 
        While on the road we would like to suggest You follow a few simple guidelines so we can continue 
        to travel for the distant future.
      </p>

      <p>
        <strong>1.</strong> First of all, respect nature and surroundings. That’s the most important asset we have. 
        Most of us love to travel because we love to be in nature. So leave the place You have spent time in, 
        in the same condition You found it.
      </p>

      <p>
        <strong>2.</strong> Leave no rubbish. It’s related to protecting nature, of course. Especially plastic, 
        which takes many years to break down. It’s not very pleasant to stay in a beautiful place when there is 
        rubbish around, so please take it with You.
      </p>

      <p>
        <strong>3.</strong> Be respectful and polite to other travellers. There are many of us on the roads 
        and we all travel in different ways and vehicles, so be friendly, respectful with each other and 
        make new friends.
      </p>

      <p>
        <strong>4.</strong> Please park your vehicle only in designated places. If You are in nature, park 
        so You don’t damage the grass, forest floor, or park too close to water, and so on. Please look after 
        nature.
      </p>

      <p>
        <strong>5.</strong> If You are staying on private land or at a private property, please be respectful 
        to the owner and owner’s property. Leave no trace, don’t damage anything, and get permission if needed.
      </p>

      <p>
        <strong>6.</strong> Support the local economy by buying local produce, visiting local markets, 
        eating and drinking at local cafes and restaurants. Many local businesses depend on tourists.
      </p>

      <p>
        <strong>7.</strong> Please drain your black and grey water only at designated places, even if You 
        have to pay for that. By doing so, we will protect nature.
      </p>

      <p>
        Many people think that tourists and travellers are leaving rubbish, damaging nature, and 
        not respecting locals and their privacy. That’s why many people are against tourists and travellers. 
        By following these simple rules we will make sure that this opinion slowly changes and we can all 
        enjoy traveling.
      </p>

      <p>
        Camplocation team wishes You safe and enjoyable travels!
      </p>
    </div>
  );
};

export default ResponsibleTravel;
